import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';

import './SrUtilityProfitAddressesDataTableHeader.less';

const SrUtilityProfitAddressesDataTableHeader = ({
  title,
  searchInput,
  onSearchInputChange,
  onAddAddress,
}) => {
  return (
    <SrBox styleName="SrUtilityProfitAddressesDataTableHeader">
      <SrBox>
        <SrText font="greycliff" weight="700" fontSize="28px">
          {title}
        </SrText>
      </SrBox>
      <SrFlex align="center">
        <SrBox marginRight="20px">
          <SrText
            font="greycliff"
            weight="700"
            color="blue300"
            cursor="pointer"
            onClick={onAddAddress}
          >
            + Add Address
          </SrText>
        </SrBox>
        <SrBox minWidth="280px" maxWidth="300px" height="28px" marginLeft="auto">
          <input
            value={searchInput}
            type="text"
            onChange={onSearchInputChange}
            placeholder="Search Address"
            styleName="searchInput"
          />
        </SrBox>
      </SrFlex>
    </SrBox>
  );
};

SrUtilityProfitAddressesDataTableHeader.displayName = 'SrUtilityProfitAddressesDataTableHeader';
SrUtilityProfitAddressesDataTableHeader.propTypes = {
  title: PropTypes.string,
  searchInput: PropTypes.string.isRequired,
  onSearchInputChange: PropTypes.func.isRequired,
  onAddAddress: PropTypes.func,
};

export default SrUtilityProfitAddressesDataTableHeader;
